import React, { useState, useEffect, useRef } from 'react'

import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

const Country = props => {
  const [country, setCountry] = useState('1')
  const zipRef = useRef('')
  const [required, setRequired] = useState()
  const [focused, setFocused] = useState(false)
  const [changed, setChanged] = useState(false)
  const [incomplete, setIncomplete] = useState(false)

  useEffect(() => {
    setRequired(props.required)
    setChanged(false)
  }, [props.required])

  const validateField = () => {
    props.onSetValid(validateZip(zipRef.current.value))
  }

  const onFocus = e => {
    setFocused(true)
    setChanged(false)
    setIncomplete(false)
  }

  const validateZip = zip => {
    const maxLength = country === '1' ? 7 : 5
    return zipRef.current.value.length === maxLength
  }

  const onBlur = e => {
    setFocused(false)
    if (zipRef.current.value === '') {
      if (changed) setRequired(true)
      setIncomplete(false)
    } else {
      setRequired(false)
      setIncomplete(!validateZip(zipRef.current.value))
    }
    validateField()
    props.onBlur(zipRef.current.value)
  }

  const onChange = e => {
    setRequired(false)
    setIncomplete(false)
    setChanged(true)
    validateField()
  }

  function handleCountryChange (e) {
    setCountry(e.target.value)
    // clear input field
  }

  function handlePostalCodeKeyDown (e) {
    const text = e.target.value

    if (e.keyCode === 8) return
    if (e.key === 'Tab') return

    if (country === '2') {
      // US don't allow letters
      if (e.key < '0' || e.key > '9') e.preventDefault()
    } else {
      // only allow letters at 1st, 3rd, 6h position
      if (text.length === 3) {
        e.target.value += ' '
        // if key press was numeric, add it
        if (e.key >= '0' && e.key <= '9') e.target.value += e.key
        e.preventDefault()
      } else if (text.length === 0 || text.length === 2 || text.length === 5) {
        console.log(e.key)
        if (e.key.length === 1 && e.key.toUpperCase().match(/[A-Z]/i)) {
          e.target.value += e.key.toUpperCase()
          if (text.length === 2) e.target.value += ' '
        }
        e.preventDefault()
      } else {
        // only numbers allowed
        if (e.key < '0' || e.key > '9') e.preventDefault()
      }
    }
  }

  return (
    <Form.Group className='mb-4'>
      <Form.Label style={{ fontSize: 13 }}>Country or region</Form.Label>
      <Form.Select
        className='rounded-0 rounded-top border-bottom-0 custom-select'
        onChange={handleCountryChange}
      >
        <option value='1'>Canada</option>
        <option value='2'>United States</option>
      </Form.Select>
      <InputGroup>
        <Form.Control
          style={{
            borderColor: !focused && (required || incomplete) && 'red'
          }}
          ref={zipRef}
          id='postalCode'
          maxLength={country === '1' ? 7 : 5}
          className='rounded-0 rounded-bottom '
          placeholder={country === '1' ? 'Postal code' : 'ZIP'}
          name='postalCode'
          onKeyDown={handlePostalCodeKeyDown}
          onFocus={onFocus}
          onChange={onChange}
          onBlur={onBlur}
          disabled={props.disabled}
        />
        {!focused && (required || incomplete) && (
          <i
            style={{
              color: 'red',
              position: 'absolute',
              padding: '7px',
              right: 6
            }}
            className='float-end bi-exclamation-circle'
          ></i>
        )}
      </InputGroup>
      {incomplete && (
        <Form.Text style={{ color: 'red' }}>
          Your {country === '1' ? 'Postal Code' : 'ZIP'} is incomplete.
        </Form.Text>
      )}
    </Form.Group>
  )
}

export default Country
